"use strict";

exports.__esModule = true;
exports.reportViewHeight = reportViewHeight;
// The editor shows a report at the size saved on it and scrolls. The view
// fits the whole report into the window whatever that size, so a report made
// taller in the editor comes back squashed to the screen, every cell shorter
// than it was drawn. Under the modern UI the saved height is a floor: the
// report fills the window when there is room and scrolls when there is not.
// The legacy view keeps fitting, as it always did.
function reportViewHeight(report, viewportHeight, modern) {
  if (!modern) {
    return viewportHeight;
  }
  var props = report && report.element && report.element.props;
  var saved = Number(props && props.height);
  return Number.isFinite(saved) && saved > 0 ? Math.max(viewportHeight, saved) : viewportHeight;
}